import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from '@dossierhq/design';
export function ValidationIssuesDisplay({ validationIssues }) {
    return (_jsx(_Fragment, { children: validationIssues.map((error, index) => (_jsx(Text, { textStyle: "body2", marginTop: 1, color: "danger", children: error.message }, index))) }));
}
//# sourceMappingURL=ValidationIssuesDisplay.js.map